// Video chat availability and transport.
//
// Chat is gated on the presence of a transcript. Any video carrying an English
// subtitle track can answer questions about itself, because the server builds
// the model context from that transcript plus the products listed on the video
// -- there is no per-video context to author by hand. Setting `chatbot: "false"`
// on a video opts it out explicitly.

export const VIDEO_CHAT_ENDPOINT = 'https://gen.philspeiser.com/ask/chat/video';

const TRANSCRIPT_LANG = 'en';

// The transcript the server reads for context. English only: it is the language
// every video is recorded in, and the translated tracks are derived from it.
export function getTranscriptTrack(videoData) {
  const subtitles = videoData?.subtitles;
  if (!Array.isArray(subtitles)) return null;
  return subtitles.find((track) => track?.srclang === TRANSCRIPT_LANG && track?.src) || null;
}

export function hasVideoChat(videoData) {
  if (String(videoData?.chatbot).toLowerCase() === 'false') return false;
  return getTranscriptTrack(videoData) !== null;
}

// Streams a reply, invoking onChunk with each decoded piece as it lands.
// The client sends only the playhead position -- the server resolves the video,
// fetches its transcript and pulls product knowledge for whatever the video
// lists in `products`.
export async function streamVideoChat({ identifier, timestamp, question, messageHistory, userName, daw }, onChunk) {
  const response = await fetch(VIDEO_CHAT_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      identifier,
      timestamp,
      question,
      message_history: messageHistory,
      user_name: userName,
      ...(daw ? { daw } : {}),
    }),
  });

  if (!response.ok) throw new Error(`Video chat server returned ${response.status}`);

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    onChunk(decoder.decode(value, { stream: true }));
  }
}
